/* Advertorial Nuuke : défilement doux vers l'offre + barre d'achat collante (après le hero, cachée quand l'offre est visible). */
(() => {
  if (window.__twAdv) return; window.__twAdv = true;
  const ready = fn => document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);
  ready(() => {
    document.addEventListener('click', e => {
      const a = e.target.closest('[data-adv-cta]');
      if (!a) return;
      const id = (a.getAttribute('href') || '').split('#')[1];
      const t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    const sticky = document.querySelector('[data-adv-sticky]');
    const hero = document.querySelector('[data-adv-hero]');
    const offer = document.getElementById('tw-buy');
    if (!sticky) return;
    sticky.hidden = false;
    let ticking = false;
    const upd = () => {
      ticking = false;
      const pastHero = sticky.hasAttribute('data-adv-sticky-top') ? true : hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      let offerVisible = false;
      if (offer) { const r = offer.getBoundingClientRect(); offerVisible = r.top < innerHeight && r.bottom > 0; }
      sticky.classList.toggle('show', pastHero && !offerVisible);
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  });
})();
